import { getRandomIntInclusive } from '@application/utils';
import {
  HeaderProfile,
  Section,
  SideLayoutContentWrapper,
  SideLayoutWrapper,
  SkeletonBox,
} from '@presentation/components';
import type { FC } from 'react';
import { Fragment, useMemo } from 'react';
import StickyBox from 'react-sticky-box';
import * as RootStyled from '../../styled';
import * as Styled from './styled';
import type { PageSkeletonProps } from './types';

export * from './types';

export const PageSkeleton: FC<PageSkeletonProps> = (props) => {
  const { backLink } = props;

  const skeletons = useMemo(() => {
    return {
      header: {
        title: {
          width: `${getRandomIntInclusive(40, 80)}%`,
          height: 62,
        },
        tags: Array(getRandomIntInclusive(1, 3))
          .fill(undefined)
          .map(() => ({
            width: getRandomIntInclusive(40, 70),
            height: 20,
          })),
      },
      section: {
        title: {
          width: getRandomIntInclusive(250, 350),
        },
        texts: Array(getRandomIntInclusive(3, 5))
          .fill(undefined)
          .map(() => {
            const topLines = getRandomIntInclusive(1, 2);
            return {
              top: { width: '90%', height: topLines * 21.5, display: 'block', marginBottom: 10 },
              bottom: {
                width: `${getRandomIntInclusive(40, 80)}%`,
                height: 21.5,
                marginBottom: 20,
              },
            };
          }),
      },
    };
  }, []);

  const skeletonSection = useMemo(() => {
    return (
      <Section>
        <Styled.SectionTitleSkeleton style={{ ...skeletons.section.title }} />
        {skeletons.section.texts.map((text, index) => (
          <Fragment key={index}>
            <SkeletonBox style={{ ...text.top }} />
            <SkeletonBox style={{ ...text.bottom }} />
          </Fragment>
        ))}
      </Section>
    );
  }, [skeletons.section.texts, skeletons.section.title]);

  return (
    <>
      <HeaderProfile
        title={<SkeletonBox style={{ ...skeletons.header.title }} />}
        tags={skeletons.header.tags.map((tag, index) => ({
          content: <div key={index} style={{ ...tag }} />,
        }))}
        backLink={backLink}
      />
      <RootStyled.PageContainer>
        <SideLayoutWrapper>
          <SideLayoutContentWrapper>
            <Styled.SlideshowSkeletonContainer>
              <Styled.SlideshowSkeletonMainWrapper>
                <Styled.SlideshowSkeletonMain />
              </Styled.SlideshowSkeletonMainWrapper>
            </Styled.SlideshowSkeletonContainer>

            {skeletonSection}
            {skeletonSection}

            <Styled.MapSkeleton />
            {skeletonSection}
          </SideLayoutContentWrapper>

          <RootStyled.StyledSideLayoutSideWrapper>
            <StickyBox offsetTop={85}>
              <Styled.SideSkeletonBox />
            </StickyBox>
          </RootStyled.StyledSideLayoutSideWrapper>
        </SideLayoutWrapper>
      </RootStyled.PageContainer>
    </>
  );
};
